export default {
    global: {
        close: 'Cerca',
        save: 'Guardar',
        continue : 'Continuar',
        confirmAndSend: 'Confirmar y enviar',
        mandatory_field: 'Este campo es obligatorio',
        checkbox_mandatory : 'Esta casilla de verificación es obligatoria',
        cancel: 'Cancelar',
        ok: 'Ok',
        yes: 'Sí',
        no: 'NO',
        post_success: 'Datos enviados bien',
        code : 'CÓDIGO:'
    },
    menu: {
        main_menu: 'Menú principal',
        lmra: 'Abrir/Cerrar LMRA',
        report_incident: 'Reportar un incidente',
        report_near_incident: 'Reportar un incidente cercano',
        risk_analysis: 'Análisis de riesgos',
        corona_analysis: 'Análisis de corona',
        scan_qr: "Escanear ETIQUETA/CÓDIGO QR",
        process_issue: "Informe de problema de proceso",
        checklist: "Ver lista de verificación",
        log_in: "Iniciar sesión",
        log_out: "Cerrar sesión",
        Emergency_numbers: "Números de emergencia"
    },
    default_lrma: {
        what_label: '¿Entiendo qué hacer?',
        how_label: '¿Sé cómo hacerlo?',
        risk_label: '¿Reconozco los peligros y riesgos?',
        control_label: '¿Puedo controlarlo?',
        default_pbm_label: '¿Tengo el EPP correcto?',
        default_pbm_question: '¿Tengo el EPP correcto?|1',
        lmra_job_state_positive: 'Bien, para comenzar el trabajo, revisaremos la LMRA cuando ocurran cambios',
        lmra_job_state_negative: 'Aún no comenzamos a trabajar.',
    },
    static_three_state_lmra: {
        getting_data_title: "Se está descargando la última versión.",
        could_not_load_newest_list_title: 'Atención',
        could_not_load_newest_list: 'Algo salió mal al obtener la última lista. Se mostrará una versión anterior guardada de la lista para que pueda continuar. Si este problema persiste, lo mejor es informar a una persona responsable.'
    },
    private_location: {
        title: '¿Estás en un lugar privado?',
        body: 'Ubicaciones privadas son ubicaciones fuera de los lugares relacionados con el trabajo.'
    },
    remarks: {
        remarksDialogTitle: '¿Observaciones?',
        remarksDialogPlaceholder: 'Escriba sus comentarios aquí',
    },
    start_stop_screen: {
        start_work_btn: "empezar a trabajar",
        stop_work_btn: "dejar de trabajar",
    },
    work_report: {
        title: "Informe de trabajo",
        placeholder: "Escriba su informe de trabajo aquí",
        skip_work_report: "Omitir",
        buildingListTitle : "Estamos creando su formulario de informe de trabajo, esto no debería llevar mucho tiempo.",
        criticalErrorTitle: 'Error:',
        criticalErrorBody: '¡Algo salió mal al crear tu formulario de informe de trabajo! Proporcione a su gerente el siguiente código de error:',
    },
    incident_report: {
        title: "Reportar incidente",
        placeholder: "¿Qué pasó?",
    },
    oeps_report: {
        title: "Informe de incidente cercano",
        placeholders: {
            machine: '¿Qué máquina?',
            who: '¿Quién estuvo involucrado?',
            what: '¿lo que pasó?',
            how: '¿Cómo sucedió esto / cómo sucedió esto?',
            stop_card: 'Seleccione Stopcard',
            location: 'Seleccionar ubicación',
            department: 'Seleccionar departamento'
        },
        external_employee: 'Es un empleado externo',
        when_text_label: '¿Cuándo sucedió esto?',
        change_date_time_btn: 'Cambiar fecha/hora'
    },
    risk_analysis: {
        title: {
            risk_default: "Análisis de riesgo",
            risk_default_sub_title: '',
            corona: "Análisis de la corona",
            corona_sub_title: 'Indique sus condiciones de trabajo a continuación y descubra cómo trabajar con seguridad.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Gravedad',
                    gravity_01: 'lesión menor, sin absentismo',
                    gravity_02: 'importante, lesiones y ausentismo',
                    gravity_07: 'invalidez permanente grave / condiciones crónicas con incapacidad (parcial) para trabajar',
                    gravity_15: 'muy grave, 1 muerto (agudo a largo plazo)',
                    gravity_40: 'desastre, múltiples muertes'
                },
                probability: {
                    label: 'Probabilidad',
                    probability_0_1: 'casi imposible de imaginar',
                    probability_0_2: 'prácticamente imposible',
                    probability_0_5: 'imaginable, pero improbable',
                    probability_01: 'improbable, caso límite',
                    probability_03: 'inusual, pero posible',
                    probability_06: 'bastante posible',
                    probability_10: 'esperado'
                },
                exposure: {
                    label: 'Exposición',
                    exposure_0_5: 'muy raro (1x por año)',
                    exposure_01: 'raramente (anualmente)',
                    exposure_02: 'a veces (mensual)',
                    exposure_03: 'ocasionalmente (semanalmente)',
                    exposure_06: 'regularmente (diariamente)',
                    exposure_10: 'constantemente',
                },
            },
            corona: {
                distance: {
                    label: 'Distancia esperada entre los demás y yo:',
                    distance_01: 'D > 8 m',
                    distance_02: '6 m < D < 8 m',
                    distance_07: '2 m < D < 6 m',
                    distance_15: '1,5 m < D < 2 m',
                    distance_40: '1 m < D < 1,5 m',
                    distance_100: 'D < 1 m'
                },
                probability: {
                    label: 'Noto que otros...',
                    probability_0_1: 'use una máscara FFP2 + gafas protectoras + ropa protectora',
                    probability_0_2: 'usar una máscara FFP2 + gafas',
                    probability_0_5: 'usar mascarilla o protector facial',
                    probability_01: 'definitivamente respetar las Directrices Corona',
                    probability_03: 'tal vez respetar las Directrices Corona',
                    probability_06: 'violar algunas Directrices de Corona',
                    probability_10: 'Violaron múltiples Directrices Corona'
                },
                exposure: {
                    label: 'Probabilidad de contacto más cercano de lo esperado:',
                    exposure_0_5: 'Muy improbable',
                    exposure_01: 'Cuando varias cosas van mal',
                    exposure_02: 'Inusual, si ciertas cosas salen mal',
                    exposure_03: 'Posiblemente, las posibilidades no son tan buenas',
                    exposure_06: 'Bastante posible, probabilidad razonable',
                    exposure_10: 'Es de esperar, casi seguro',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'ninguno',
                kinneyCode2: 'atención requerida',
                kinneyCode3: 'las medidas requeridas se pueden planificar',
                kinneyCode4: 'mejora inmediata',
                kinneyCode5: 'dejar de funcionar'
            },
            corona: {
                kinneyCode1: 'Riesgo aceptable: No se requieren medidas de protección adicionales',
                kinneyCode2: 'Posible riesgo: Necesita atención',
                kinneyCode3: 'Riesgo mayor: tomar medidas de protección',
                kinneyCode4: 'Alto riesgo: tomar mayores medidas de protección',
                kinneyCode5: 'Riesgo muy alto: intente ajustar la actividad, si es imposible, tome las máximas medidas de protección'
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: 'Conozco y respeto las Directrices Corona que se aplican en mi entorno de trabajo.',
                supportiveText2: 'Conozco y respeto las pautas de Corona que se aplican. Pido expresamente a las personas de mi entorno de trabajo que también cumplan con las pautas de Corona. No son necesarias más medidas de protección adicionales.',
                supportiveText3: 'Me desinfecté las manos al inicio y al final de la actividad. Llevo un protector facial o una mascarilla bucal adecuada en combinación con gafas (de seguridad). Las personas en mi entorno de trabajo también deben usar al menos un protector facial o una máscara nasal (preferiblemente junto con gafas de seguridad). Sé utilizar correctamente estos equipos de protección colectiva y aplicarlo en la práctica. Conozco y respeto las Directrices Corona que se aplican y pido expresamente a las personas de mi entorno de trabajo que también cumplan con las Directrices Corona.',
                supportiveText4: 'Me desinfecté las manos al comienzo y al final de la actividad y después de cualquier contacto inseguro. Uso una máscara protectora para la boca y la nariz (preferiblemente una máscara de protección respiratoria FFP2) en combinación con un protector facial o gafas protectoras. Sé cómo usar estos equipos de protección personal (EPP) correctamente y aplicarlo en la práctica. Conozco las pautas de Corona que se aplican en el entorno de trabajo y, por supuesto, continúo respetando estas pautas de Corona. Pido a las personas en mi entorno de trabajo que también tomen las medidas de seguridad necesarias y observen las pautas de Corona.',
                supportiveText5: 'Primero considero si la actividad se puede llevar a cabo de otra manera sin contacto directo con otras personas. Si esto no es posible, tomaré todas las medidas de seguridad posibles. Me desinfecté las manos al inicio y al final de la actividad. Llevo guantes protectores. Llevo una máscara de protección respiratoria (al menos FFP2) en combinación con un protector facial o gafas protectoras y ropa protectora. Sé cómo usar estos equipos de protección personal (EPP) correctamente y aplicarlo en la práctica. Conozco las pautas de Corona que se aplican en el entorno de trabajo y, por supuesto, continúo respetando estas pautas de Corona. Les pido a las personas en mi entorno de trabajo que también tomen las medidas de seguridad necesarias y observen cuidadosamente las pautas de Corona.'
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Atención',
                body: 'Está a punto de cerrar esta ventana sin enviar el informe de análisis de riesgo actual. ¿Estás seguro de que quieres salir de la página?'
            },
            corona: {
                title: 'Atención',
                body: 'Está a punto de cerrar esta ventana sin enviar el informe de análisis Corona actual. ¿Estás seguro de que quieres salir de la página?'
            }
        },
        report_title: 'Informe de análisis',
        placeholder_report: 'Describa / aclare la situación'
    },
    process_issue: {
        title: "Informar un problema de proceso",
        placeholders: {
            issue_type_select: 'Seleccionar tipo de problema',
            failure_detail: 'Seleccionar detalle del problema',
            who: '¿Quién estuvo involucrado?',
            description: 'Describa el problema',
            cnf: 'CNF?',
            comment: 'Observaciones adicionales / Comentarios',
            other: 'Otro'
        }
    },
    checklist: {
        getting_data_title: "Se recopila la última lista de verificación"
    },
    data_transfer: {
        post_busy: 'Por favor espere, los datos se están enviando.',
        post_success: 'Datos enviados correctamente.'
    },
    gdpr_disclaimer: {
        title: 'Propuesta de RGPD:',
        body: 'Al enviar un elemento de la aplicación lmra-first, los siguientes elementos se almacenarán en la base de datos: ubicación actual (GPS - coordenadas (después de la confirmación)) y la hora exacta (y solo en ese momento). Ninguno de esos artículos se venderá a otras partes, organizaciones. Los datos almacenados solo se utilizarán en el orden del proyecto y las condiciones de trabajo relacionadas',
        accept_btn: 'Acepto',
        decline_btn: 'Salir de la aplicación'
    },
    data_notice: {
        button_text: '¿Qué pasa con esta información?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings: {
        alert_cn_pid_nf_title: 'Vaya, parece que olvidaste algo:',
        alert_cn_pid_nf_body: 'No se completó el nombre del cliente y/o ID del proyecto, verifique los valores',
        client_select_placeholder: 'Seleccionar un cliente',
        project_select_placeholder: 'Seleccione un Proyecto',
        client_not_in_list_label: 'El cliente no está en la lista',
        project_not_in_list_label: 'Proyecto no en la lista',
        client_name: 'Nombre del cliente',
        project_id: 'ID del proyecto',
        project_distance: 'Distancia del Proyecto',
        project_shift: 'Turno de proyecto',
        user_initials: 'Tus iniciales',
        project_tag_code_label : 'Proyecto TAG-Código',
        warning: {
            intro: 'Ahora estás usando la entrada manual para',
            Reason_server: '¡porque no se pudieron cargar los datos del servidor!',
            Reason_client_not_listed: '¡porque el cliente no estaba en la lista actual!',
            Reason_project_not_listed: '¡porque el proyecto no estaba en la lista actual!',
            dbl_check: '¡Revisa dos veces todos tus valores antes de guardar!',
            admin_msg: '¡Si este mensaje continúa apareciendo, comuníquese con su administrador y repórtelo!'
        },
        input_errors: {
            no_client_selected: 'Por favor seleccione un cliente',
            no_project_selected: 'Seleccione un proyecto',
        },
        loading_cap: 'Cargando datos del servidor',
        custom_shifts_labels: {
            open_field : 'Campo abierto'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Error de escaneo",
                body : "Se detectó un formato de datos QR no válido"
            },
            error_popup_notice_manual_mode : {
                title : "Algo salió mal",
                body : "Algo salió mal al cargar datos de RRQRCode, cambiando al modo manual"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Cargando flujo de cámara...',
            default_error_button_test: 'Salir'
        },
        overlay_view: {
            title : 'Escanear TAG - Código',
            info_manual: '¿Tiene problemas para escanear? Usar entrada manual',
            manual_btn: 'Habilitar entrada manual.',
            errors : {
                invalid_tag_title: 'CÓDIGO DE ETIQUETA no válido',
                invalid_tag_body: 'El código que ha escaneado no es un CÓDIGO DE ETIQUETA válido, escanee un CÓDIGO DE ETIQUETA válido o cambie a entrada manual.',
                error_btn_txt: 'Habilitar entrada manual'
            }
        }
    },
    errors: {
        checklistNotLoaded: 'Algo salió mal al obtener la lista, intente nuevamente más tarde.',
        EmergencyNumbersOverviewNotLoaded: 'Algo salió mal al obtener la lista, intente nuevamente más tarde.',
        missing_critical_resource_title: 'Error al cargar datos:',
        missing_critical_resource: 'Falta un recurso de la aplicación. Informe el siguiente código al administrador.',
        app_corrupt: 'Parece que la configuración de la aplicación está dañada. Póngase en contacto con su administrador.',
        data_save_failed: 'No se pudieron enviar los datos, inténtalo de nuevo más tarde...',
        camera: {
            NotAllowedError: 'ERROR: debe otorgar permiso para acceder a la cámara',
            NotFoundError: 'ERROR: No hay cámara en este dispositivo',
            NotSupportedError: 'ERROR: se requiere contexto seguro (HTTPS, localhost)',
            NotReadableError: 'ERROR: ¿Ya se está utilizando la cámara?',
            OverconstrainedError: 'ERROR: las cámaras instaladas no son adecuadas',
            StreamApiNotSupportedError: 'ERROR: Stream API no es compatible con este navegador',
        },
        no_internet: 'Oooops... ¡Estás desconectado, revisa tu conexión a Internet!',
        input_validation: {
            char_limit: 'Se permite un máximo de %n caracteres'
        },
        auth0 :{
            unverified_email : {
                error: 'Error: ¡La dirección de correo electrónico no está verificada! ¡Revisa tus correos!',
                info : 'Para obtener acceso a esta aplicación <b>debe verificar su dirección de correo electrónico</b>.<br/><br/>En breve <b>recibirá un correo electrónico</b> <b>de |SENDER| </b><br/><br/><i>Para verificar su dirección de correo electrónico. Siga las instrucciones del correo electrónico</i>'
            }
        }
    },
    noDataText: "Informacion no disponible ...",
    defaultDynamicQuestion: '{"dynamic_questions":[{"id":null,"question":"¿Tengo el EPP correcto?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'Correo electrónico',
        passwordLabel : 'Contraseña',
        rememberMeLabel : "Acuérdate de mí",
        logInBtn: "Iniciar sesión",
        logOutBtn: "desconectar",
        verifyMFABtn : "Verificar",
        errorPopupTitle : "Error",
        confirmIdentify : "¿Todavia tu?",
        errors :{
            required : "Requerido",
            invalidEmail : "Email inválido",
            unknownError : "Un error desconocido ocurrió"
        },
        registerNewAccountBtn : "Crea una cuenta nueva.",
        forgotPassword : "Has olvidado tu contraseña"
    },
    lmraComponent : {
        loadingProjectData : 'Preparando su formulario LMRA, por favor espere',
        startWorkQrDialog:{
            title : "Seleccionar método de inicio:",
            body : "Si tiene presente el código QR de Risk-reflex, seleccione Código QR; de lo contrario, utilice el método de entrada manual",
            positive_btn : "código QR",
            negative_btn : "Método manual"
        },
        errors : {
            unknownError : "Un error desconocido ocurrió",
            noListDataFound : "Error: ¡NO SE ENCONTRARON DATOS DE LA LISTA! VOLVER A LA LMRA PREDETERMINADA",
            noDefaultListFound: '¡No hay lista predeterminada disponible! ¡Usando LMRA PREDETERMINADO!',
        }
    },
    customLmraLists : {
        buildingListTitle: "Construyendo su formulario LMRA, esto no debería llevar mucho tiempo",
        criticalErrorTitle: 'Error:',
        criticalErrorBody: '¡Algo salió mal al construir su formulario LMRA! ¡Ahora cargaremos el LMRA predeterminado! proporcione a su gerente el siguiente código de error: ',
    },
    workSessions :{
        global : {
          expiredLabel : "Caducado"
        },
        resumeSessionDialog : {
            titleActiveSession : "Sesión activa encontrada",
            titleActiveSessionExpired : "(Caducado) Sesión activa encontrada",
        },
        workSessionServiceNaDialog :{
            title : 'SERVICIO DE SESIÓN DE TRABAJO NO DISPONIBLE',
            body : 'Lo sentimos, no podemos determinar si tiene una sesión abierta<br/><br/>' +
                '<b>El módulo LMRA está bloqueado: no puede iniciar ni cerrar una sesión. </b><br/> Sin embargo, aún puede enviar informes de incidentes (fuera de la sesión)<br/>' +
                'Recibirás una notificación cuando el servicio de sesión esté disponible<br/><br/>' +
                'si este error persiste, notifique a su administrador...'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Lo sentimos: <b>El Módulo LMRA está actualmente bloqueado: no puede iniciar ni cerrar una sesión. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'La respuesta del servidor no contiene datos de sesión',
                    could_not_save_session : 'No se pudieron guardar los datos de la sesión localmente...',
                    invalid_session_data : 'Los datos de la sesión no son válidos, los datos pueden estar dañados'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Un error desconocido ocurrió",
            notFound : "No se encontró ningún código de grupo",
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Número de emergencia predeterminado",
        getting_data_title: "Obtener los últimos números"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Lista de verificación activa",
                other_checklists : "Otras listas de verificación"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Visualizando:"
            },
            warning_message : "Está viendo una lista de verificación que no es la lista activa actual. Para ver la lista activa, use la pestaña \"Lista de verificación activa\" en la parte superior"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "La versión está actualizada.",
            version_minor_update : "Versión más reciente disponible (es posible que no esté disponible para su inquilino)",
            update_required : "¡Advertencia! Esta aplicación está desactualizada, la aplicación debería actualizarse automáticamente. Si este mensaje persiste, comuníquese con el administrador."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Tipo de código QR incorrecto",
                    body : "Este tipo de código QR no es compatible aquí"
                },
                wrong_tenant : {
                    title : "Inquilino equivocado",
                    body : "Su empresa no puede utilizar este código QR"
                },
                invalid_qr_code : {
                    title : "Código QR no válido",
                    body : "Este no es un código QR de Risk Reflex válido y no se puede utilizar"
                },
                invalid_qr_data : {
                    title : "Datos de código QR no válidos",
                    body : "Este código QR no se puede traducir, el código QR puede estar dañado"
                }
            },
            title : "Escanear el código QR de Risk-Reflex",
            info_manual: '¿Tiene problemas para escanear? Usar entrada manual',
            manual_btn: "Cambiar al modo manual"
        }
    }
}